import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20landscape%20with%20warm%20golden%20amber%20and%20teal%20gradient%20waves%2C%20flowing%20curved%20lines%2C%20modern%20minimal%20digital%20art%2C%20smooth%20gradient%20shapes%2C%20clean%20and%20elegant%20composition%2C%20no%20text%2C%20no%20people&width=1600&height=800&seq=hero-bg-91n&orientation=landscape"
        alt="91n官方入口导航"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-sm md:text-base font-medium text-primary-300 tracking-widest uppercase mb-4">
            安全 · 稳定 · 可靠
          </h2>
          <h3 className="text-3xl md:text-5xl lg:text-6xl font-bold font-serif text-background-50 leading-tight mb-6">
            91n官方入口
            <span className="block text-primary-400 mt-2">最新地址导航</span>
          </h3>
          <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-xl mx-auto mb-8">
            91n是您值得信赖的内容平台，提供91n最新入口、91n官方地址及91n使用指南。快速找到91n正版渠道，享受91n带来的优质体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category?tab=address"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-md text-sm font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer"
            >
              查看最新地址
            </Link>
            <Link
              to="/category?tab=guide"
              className="border border-background-50/40 hover:border-background-50 text-background-50 hover:bg-background-50/10 px-8 py-3 rounded-md text-sm font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer"
            >
              使用教程
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-3 bg-background-50/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}